import { render, staticRenderFns } from "./RubricWrapper.vue?vue&type=template&id=5d40907c"
import script from "./RubricWrapper.vue?vue&type=script&lang=js"
export * from "./RubricWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports